var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 277,
    viewBox: "0 0 518 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.6467,
    cy: 56.7246,
    rx: 1.5,
    ry: 1.55053,
    transform: "rotate(90 62.6467 56.7246)",
    fill: "white",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.506,
    cy: 269.87,
    rx: 1.5,
    ry: 1.55053,
    transform: "rotate(90 469.506 269.87)",
    fill: "white",
    fillOpacity: 0.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.381,
    cy: 13.1201,
    rx: 1.5,
    ry: 1.55053,
    transform: "rotate(90 508.381 13.1201)",
    fill: "white",
    fillOpacity: 0.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.624,
    cy: 19.4565,
    rx: 1.5,
    ry: 1.55053,
    transform: "rotate(90 183.624 19.4565)",
    fill: "white",
    fillOpacity: 0.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.474,
    cy: 251.063,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 331.474 251.063)",
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.564,
    cy: 275.908,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 43.564 275.908)",
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.932,
    cy: 162.144,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 217.932 162.144)",
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.587,
    cy: 52.2246,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 241.587 52.2246)",
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.886,
    cy: 91.4536,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 459.886 91.4536)",
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.919,
    cy: 1.0918,
    rx: 1,
    ry: 1.03369,
    transform: "rotate(90 460.919 1.0918)",
    fill: "white",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 402.279,
    cy: 53.7247,
    r: 0.508352,
    transform: "rotate(90 402.279 53.7247)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.481,
    cy: 145.913,
    r: 0.508352,
    transform: "rotate(90 343.481 145.913)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.481,
    cy: 145.913,
    r: 0.508352,
    transform: "rotate(90 343.481 145.913)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.506,
    cy: 237.448,
    r: 0.508352,
    transform: "rotate(90 516.506 237.448)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.051,
    cy: 11.2261,
    r: 0.508352,
    transform: "rotate(90 140.051 11.2261)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49458,
    cy: 179.258,
    r: 0.508352,
    transform: "rotate(90 1.49458 179.258)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.051,
    cy: 211.949,
    r: 0.508352,
    transform: "rotate(90 140.051 211.949)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.528,
    cy: 117.145,
    r: 0.508352,
    transform: "rotate(90 101.528 117.145)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.028,
    cy: 274.908,
    r: 0.508352,
    transform: "rotate(90 261.028 274.908)",
    fill: "white",
    fillOpacity: 0.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.312,
    cy: 180.258,
    r: 0.508352,
    transform: "rotate(90 403.312 180.258)",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d99d56dee9ec5cbc909a76880c70d57e.svg";
export { ForwardRef as ReactComponent };